export const tickets = [
  {
    id: "PC-2025-001",
    title: "Invoice Discrepancy - October Billing",
    submittedBy: "Ashley Palma",
    priority: "high",
    status: "open",
    category: "Billing",
    description: "There appears to be a discrepancy in the October billing statement. Need clarification.",
    replies: 2,
    lastUpdated: "2 hours ago"
  },
  {
    id: "PC-2025-002",
    title: "Contract Renewal Discussion",
    submittedBy: "Saccharine Elupre",
    priority: "medium",
    status: "in-progress",
    category: "Contracts",
    description: "Would like to discuss contract renewal terms and conditions for 2026.",
    replies: 6,
    lastUpdated: "1 day ago"
  },
  {
    id: "PC-2025-003",
    title: "Service Level Agreement Query",
    submittedBy: "Emily Rodriguez",
    priority: "medium",
    status: "open",
    category: "Service",
    description: "Questions regarding SLA response times and coverage.",
    replies: 1,
    lastUpdated: "3 hours ago"
  },
  {
    id: "PC-2025-004",
    title: "Additional Services Request",
    submittedBy: "James Wilson",
    priority: "low",
    status: "in-progress",
    category: "Service",
    description: "Interested in adding additional team members to our service package.",
    replies: 4,
    lastUpdated: "2 days ago"
  },
  {
    id: "PC-2025-005",
    title: "Partnership Opportunity",
    submittedBy: "Lisa Anderson",
    priority: "high",
    status: "resolved",
    category: "Partnerships",
    description: "Exploring potential partnership opportunities for mutual benefit.",
    replies: 8,
    lastUpdated: "4 days ago"
  }
];
